import { useQuery } from "@tanstack/react-query";
import { AudioType } from "@constants/consts";
import { useNoticeError } from "@utils/common/newRelic";
import { fetchByEndpoint } from "@utils/pageContent/fetchData";

type limitedAudioType = Exclude<AudioType, AudioType.TRACK | AudioType.PLAYOUT>;

interface UseAudioEntryProps<T> {
  audioType: limitedAudioType;
  slug: string;
  initialData?: T | null;
}

export const useAudioEntry = <T extends AudioStationEntry | AudioShowEntry>({
  audioType,
  slug,
  initialData,
}: UseAudioEntryProps<T>) => {
  const audioQueryKey = [audioType, slug];

  const result = useQuery({
    queryKey: audioQueryKey,
    queryFn: () => fetchByEndpoint<T>(`/api/audio/${slug}`),
    initialData: initialData,
    enabled: !initialData,
  });

  useNoticeError(result.error, { queryKey: audioQueryKey.join(",") });

  return result;
};
